const ClearIcon = () => (
  <svg
    width="10"
    height="10"
    viewBox="0 0 10 10"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
  >
    <path d="M1 1L9 9M1 9L9 1" strokeLinecap="round" />
  </svg>
);

export default ClearIcon;